import { useState } from "react";
import { Outlet, NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, MessageSquare, FileText,
  HardDrive, Wrench, Circle, ChevronRight, CalendarClock,
  MessageCircle, X, Send, ArrowRight
} from "lucide-react";

const LOGO_BASE64 = "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";

const NAV = [
  { to: "/dashboard",       icon: LayoutDashboard, label: "Dashboard",                 group: "main" },
  { to: "/ai-analyst",      icon: MessageSquare,   label: "Ellerston Agent",            group: "main" },
  { to: "/vba-killer",      icon: FileText,        label: "Ellerston Report Generator", group: "main" },
  { to: "/database",        icon: HardDrive,       label: "Ellerston Drive",            group: "main" },
  { to: "/schedule-tasks",  icon: CalendarClock,   label: "Ellerston Scheduler",        group: "main" },
];

const NAV_COMMANDS = [
  { keywords: ["dashboard", "home", "overview", "main", "kpi", "metrics"], path: "/dashboard", label: "Dashboard" },
  { keywords: ["agent", "ai", "chat", "analyst", "question", "ask"], path: "/ai-analyst", label: "Ellerston Agent" },
  { keywords: ["report", "pdf", "generate", "vba", "document"], path: "/vba-killer", label: "Ellerston Report Generator" },
  { keywords: ["drive", "files", "storage", "database", "upload", "folder"], path: "/database", label: "Ellerston Drive" },
  { keywords: ["schedule", "task", "workflow", "automate", "automation", "cron"], path: "/schedule-tasks", label: "Ellerston Scheduler" },
];

const HELP_RESPONSES = {
  greeting: "Welcome to Ellerston Capital's Intelligence Platform! I can help you navigate. Try asking me:\n\n• \"Take me to the dashboard\"\n• \"Open the report generator\"\n• \"Show me the AI agent\"\n• \"Go to drive\"\n• \"What can I do here?\"",
  capabilities: "Here's what's available:\n\n📊 **Dashboard** — Portfolio analytics & market data\n🤖 **Ellerston Agent** — AI-powered data analysis\n📄 **Report Generator** — Institutional PDF reports\n📁 **Ellerston Drive** — File management & storage\n⏰ **Scheduler** — Automated workflows\n\nJust tell me where you'd like to go!",
  fallback: "I'm not sure I understand. Try asking me to navigate somewhere, like:\n• \"Go to dashboard\"\n• \"Open reports\"\n• \"What can I do here?\"",
};

function NavigationAgent() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: "assistant", content: HELP_RESPONSES.greeting }
  ]);
  const [input, setInput] = useState("");
  const navigate = useNavigate();

  const processMessage = (text) => {
    const lower = text.toLowerCase().trim();
    setMessages(prev => [...prev, { role: "user", content: text }]);
    setInput("");

    // Check for help/capabilities
    if (lower.includes("help") || lower.includes("what can") || lower.includes("capabilities") || lower.includes("features")) {
      setTimeout(() => {
        setMessages(prev => [...prev, { role: "assistant", content: HELP_RESPONSES.capabilities }]);
      }, 300);
      return;
    }

    // Check for navigation commands
    for (const cmd of NAV_COMMANDS) {
      if (cmd.keywords.some(kw => lower.includes(kw))) {
        setTimeout(() => {
          setMessages(prev => [...prev, {
            role: "assistant",
            content: `Navigating to **${cmd.label}**... ✓`,
            action: cmd.path
          }]);
          navigate(cmd.path);
          setTimeout(() => setOpen(false), 1200);
        }, 300);
        return;
      }
    }

    // Fallback
    setTimeout(() => {
      setMessages(prev => [...prev, { role: "assistant", content: HELP_RESPONSES.fallback }]);
    }, 300);
  };

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setOpen(o => !o)}
        className={`fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 ${
          open ? "bg-[#1a1a1a] rotate-0" : "bg-[#A8A67A] hover:bg-[#8E8C64] hover:scale-105"
        }`}
        data-testid="nav-agent-toggle"
      >
        {open ? <X className="w-5 h-5 text-white" /> : <MessageCircle className="w-5 h-5 text-white" />}
      </button>

      {/* Chat panel */}
      {open && (
        <div className="fixed bottom-24 right-6 z-50 w-96 bg-white border border-border shadow-2xl flex flex-col" style={{ maxHeight: "480px" }} data-testid="nav-agent-panel">
          {/* Header */}
          <div className="px-4 py-3 bg-[#1a1a1a] flex items-center gap-3">
            <div className="w-8 h-8 bg-[#A8A67A] rounded-full flex items-center justify-center flex-shrink-0">
              <MessageCircle className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="text-sm font-semibold text-white">Ellerston Navigator</p>
              <p className="text-[10px] text-white/50">Ask me to take you anywhere</p>
            </div>
            <div className="ml-auto flex items-center gap-1.5">
              <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
              <span className="text-[10px] text-emerald-400">Online</span>
            </div>
          </div>

          {/* Messages */}
          <div className="flex-1 overflow-y-auto p-4 space-y-3" style={{ maxHeight: "320px" }}>
            {messages.map((msg, i) => (
              <div key={i} className={`flex ${msg.role === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[85%] px-3 py-2.5 text-xs leading-relaxed ${
                  msg.role === "user"
                    ? "bg-[#A8A67A] text-white"
                    : "bg-[#f5f4ee] text-foreground"
                }`}>
                  <span className="whitespace-pre-wrap">
                    {msg.content.split(/\*\*(.*?)\*\*/g).map((part, j) =>
                      j % 2 === 1 ? <strong key={j} className="font-semibold">{part}</strong> : part
                    )}
                  </span>
                  {msg.action && (
                    <div className="flex items-center gap-1 mt-1.5 text-[#A8A67A]">
                      <ArrowRight className="w-3 h-3" />
                      <span className="font-semibold text-[10px]">Redirecting...</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Quick actions */}
          <div className="px-4 py-2 border-t border-border flex gap-1.5 flex-wrap">
            {["Dashboard", "Agent", "Reports", "Drive", "Scheduler"].map(label => (
              <button
                key={label}
                onClick={() => processMessage(`Go to ${label}`)}
                className="text-[10px] px-2.5 py-1 bg-[#f5f4ee] hover:bg-[#A8A67A] hover:text-white text-foreground transition-colors font-medium"
              >
                {label}
              </button>
            ))}
          </div>

          {/* Input */}
          <div className="p-3 border-t border-border flex gap-2">
            <input
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === "Enter" && input.trim() && processMessage(input)}
              placeholder="Where would you like to go?"
              className="flex-1 px-3 py-2 text-xs border border-border bg-background focus:outline-none focus:ring-1 focus:ring-[#A8A67A] rounded-none"
              data-testid="nav-agent-input"
            />
            <button
              onClick={() => input.trim() && processMessage(input)}
              className="bg-[#A8A67A] text-white px-3 py-2 hover:bg-[#8E8C64] transition-colors"
              data-testid="nav-agent-send"
            >
              <Send className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default function Layout() {
  const location = useLocation();

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Sidebar */}
      <aside className="sidebar flex flex-col" data-testid="sidebar">
        {/* Logo */}
        <div className="px-5 py-5 border-b border-white/10">
          <div className="flex items-center gap-3">
            <img
              src="/ellerston-logo-white.png"
              alt="Ellerston Capital"
              className="h-10 w-auto"
            />
          </div>
        </div>

        {/* Status indicator */}
        <div className="px-5 py-3 border-b border-white/5">
          <div className="flex items-center gap-2">
            <Circle className="w-2 h-2 fill-emerald-500 text-emerald-500" />
            <span className="text-[10px] text-white/50 uppercase tracking-wider">3 Sources Live</span>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
          <p className="text-[9px] text-white/30 uppercase tracking-widest px-2 mb-2">Platform</p>
          {NAV.filter(n => n.group === "main").map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `sidebar-item flex items-center gap-3 px-3 py-2.5 text-sm rounded-none group ${
                  isActive
                    ? "bg-[#A8A67A]/30 text-white border-l-2 border-[#C4C29A]"
                    : "text-white/50 hover:text-white hover:bg-white/5 border-l-2 border-transparent"
                }`
              }
            >
              <Icon className="w-4 h-4 flex-shrink-0" strokeWidth={1.5} />
              <span className="font-medium">{label}</span>
              {location.pathname === to && (
                <ChevronRight className="w-3 h-3 ml-auto text-[#C4C29A]" />
              )}
            </NavLink>
          ))}

          <p className="text-[9px] text-white/30 uppercase tracking-widest px-2 mt-5 mb-2">Internal Tools</p>
          {[
            { label: "POC1", href: "https://dev.d2o89ul1nq3i99.amplifyapp.com" },
            { label: "POC2", href: "https://dev.d3quyq4guc4kx0.amplifyapp.com" },
            { label: "POC3", href: "https://financial-gen.emergent.host/" },
            { label: "POC4", href: "https://ellerston-poc-app.ddconsult.com.au/" },
          ].map(({ label, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`nav-${label.toLowerCase()}`}
              className="sidebar-item flex items-center gap-3 px-3 py-2.5 text-sm rounded-none text-white/50 hover:text-white hover:bg-white/5 border-l-2 border-transparent"
            >
              <Wrench className="w-4 h-4 flex-shrink-0" strokeWidth={1.5} />
              <span className="font-medium">{label}</span>
            </a>
          ))}
        </nav>

        {/* Bottom */}
        <div className="px-5 py-4 border-t border-white/5">
          <p className="text-[9px] text-white/25 leading-relaxed">
            Ellerston Capital<br/>Intelligence Platform<br/>
            <span className="text-white/15">v2.0 — Prototype</span>
          </p>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-y-auto bg-background" data-testid="main-content">
        <Outlet />
      </main>

      {/* Navigation Agent */}
      <NavigationAgent />
    </div>
  );
}
